import { render, staticRenderFns } from "./DealerDrawer.vue?vue&type=template&id=54564127&scoped=true"
import script from "./DealerDrawer.vue?vue&type=script&lang=js"
export * from "./DealerDrawer.vue?vue&type=script&lang=js"
import style0 from "./DealerDrawer.vue?vue&type=style&index=0&id=54564127&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54564127",
  null
  
)

export default component.exports